import { render, staticRenderFns } from "./OTPVerify.vue?vue&type=template&id=78ea1f9c&scoped=true"
import script from "./OTPVerify.vue?vue&type=script&lang=js"
export * from "./OTPVerify.vue?vue&type=script&lang=js"
import style0 from "./OTPVerify.vue?vue&type=style&index=0&id=78ea1f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ea1f9c",
  null
  
)

export default component.exports